import { render, staticRenderFns } from "./HairTypesRegistryEditForm.vue?vue&type=template&id=61e8abe2"
import script from "./HairTypesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./HairTypesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports